import { useOrganizationStore } from '@shared/hooks/state/OrganizationContainer';
import { useEffect, useMemo } from 'react';
import useResolveCurrentOrg from './useResolveCurrentOrg';

export function useCurrentOrgInviteFetching() {
    const { organizationId } = useResolveCurrentOrg();
    const isLoading = useOrganizationStore((state) => state.loadingData.invites);
    const orgInvites = useOrganizationStore((state) => state.invites);

    const invites = useMemo(() => {
        if (!organizationId) return null;
        return orgInvites.find((org) => org.organizationId === organizationId)?.invites ?? [];
    }, [organizationId, orgInvites]);

    useEffect(() => {
        async function fetchInvites() {
            if (!organizationId || useOrganizationStore.getState().loadingData.invites == true) return;
            useOrganizationStore.getState().handleLoadingDataChange('invites', true);
            if (useOrganizationStore.getState().invites.find((org) => org.organizationId === organizationId)?.invites) {
                useOrganizationStore.getState().handleLoadingDataChange('invites', false);
                return;
            }

            try {
                const result = await useOrganizationStore.getState().loadInvites(organizationId);
                if (result?.resultType !== 'Ok') {
                    console.error('Failed to load invites for organization:', organizationId);
                }
            } catch (error) {
                console.error('Error loading invites.');
            } finally {
                useOrganizationStore.getState().handleLoadingDataChange('invites', false);
            }
        }

        fetchInvites();
    }, [organizationId]);

    return { invites, isLoading };
}
